import { Image, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import React from "react";

import { Button, UpgradePage } from "../../../components";
import { DefaultLayout } from "../../layouts";

const AiInterviewerUpgradePage: React.FC = () => {
  const body = React.useMemo(
    () => (
      <UnorderedList spacing={3}>
        <ListItem>
          <Text>
            <Text as="span" fontWeight="700">
              Scale recruiter capacity without adding workload
            </Text>{" "}
            by automating first-round interviews for consistent, unbiased
            interviews
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            <Text as="span" fontWeight="700">
              Give candidates a fair shot
            </Text>{" "}
            with a structured, two-way conversation that goes deeper than a
            resume
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            <Text as="span" fontWeight="700">
              Leverage your data on BrightHire to set up and scale quickly
            </Text>{" "}
            by generating guides and scoring rubrics from existing intakes and
            interviews
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            <Text as="span" fontWeight="700">
              Connect to your hiring workflow
            </Text>{" "}
            so you can automate invitations or review summaries, transcripts,
            and scores directly in your ATS
          </Text>
        </ListItem>
      </UnorderedList>
    ),
    []
  );

  return (
    <DefaultLayout>
      <UpgradePage
        h={{ lg: "100vh" }}
        pt={{ base: 8, lg: 0 }}
        px={6}
        pb={{ base: 150, sm: 24, lg: 0 }} // magic number for base to account for the fixed bottom button
        maxWidth={475}
        header={
          <>
            BrightHire Screen:{" "}
            <Text as="span" color="gray.600">
              Your always-on AI interviewer
            </Text>
          </>
        }
        body={body}
        buttonText="Get in touch with our team"
        bhEvent={{
          action: "click",
          category: "marketing_click_tracking",
          label: "screen_upgrade",
        }}
        splash={
          <Image
            src="/static/images/screen-upgrade.png"
            alt="BrightHire Screen promotional image"
          />
        }
        requestSubmitted={false}
        onClick={() =>
          window.open(
            "https://brighthire.com/ai-interviewer/request-a-demo",
            "_blank",
            "noopener,noreferrer"
          )
        }
        secondaryButton={
          <Button
            as="a"
            href="https://brighthire.com/ai-interviewer"
            target="_blank"
            rel="noopener noreferrer"
            variant="link"
            width="100%"
            mt="2"
            py="2"
            px="4"
            bhEvent={{
              action: "click",
              category: "marketing_click_tracking",
              label: "screen_learn_more",
            }}
          >
            Learn more about BrightHire Screen
          </Button>
        }
      />
    </DefaultLayout>
  );
};

export { AiInterviewerUpgradePage };
